import { render, staticRenderFns } from "./LocalCampos.vue?vue&type=template&id=923948a2&scoped=true&"
import script from "./LocalCampos.vue?vue&type=script&lang=js&"
export * from "./LocalCampos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923948a2",
  null
  
)

export default component.exports